define('lib/backbone/Backbone.PodioScrollPaginatedCollection',['require','underscore','lib/backbone/Backbone.PodioCollection'],function(require) {

  var _ = require('underscore');
  var CollectionPodioBase = require('lib/backbone/Backbone.PodioCollection');

  return CollectionPodioBase.extend({
    fetchWithPost: false,           /* do a POST request instead of GET */
    itemsPerPage: 15,
    currentPage: 0,
    endReached: false,

    setItemsPerPage: function(number) {
      this.itemsPerPage = number;
    },

    fetch: function(options) {
      var data;
      var self = this;

      this.trigger('scrollPagination:loadingPage', this.currentPage);
      options = options || {};
      options.data = options.data || {};
      _.extend(options.data, {
        offset: options.offset || 0,
        limit: options.limit || this.calculateLimit(1)
      });

      if (this.fetchWithPost) {
        data = options.data;
        delete options.data;

        return this.request('post', this.url, data, options).done(function(responseData) {
          var method = options.reset ? 'reset' : 'set';
          var resp = self.parse(responseData);

          self[method](resp, options);
          if (options.success) {
            options.success(self, resp, options);
          }
        });
      } else {
        return this._super(options);
      }
    },

    getPage: function(page, options) {
      page = page || 1;
      if (page === 1 || page < this.currentPage) {
        this.endReached = false;
      }
      this.appendCollection = page <= this.currentPage ? false : page !== 1;
      options = options || {};
      _.extend(options, {
        offset: this.calculateOffset(page),
        limit: this.calculateLimit(page),
        silentLoading: this.appendCollection
      });

      if (this.appendCollection) {
        options.remove = false;
      } else {
        options.reset = true;
      }

      this.currentPage = page;
      return this.fetch(options);
    },

    getNextPage: function(options) {
      this.getPage(this.currentPage+1, options);
    },

    parse: function(response) {
      var results;
      var finalResults;

      // handle API proxy
      if (!_.isUndefined(response.data)) {
        if (response.status === 'error') {
          return;
        } else {
          results = response.data.object;
        }
      } else {
        results = response;
      }

      if (this.appendCollection && (results.length > this.itemsPerPage)) {
        finalResults = results.slice(0, -1);
      } else if (!this.appendCollection && results.length > (this.currentPage * this.itemsPerPage)) {
        finalResults = results.slice(0, -1);
      } else {
        finalResults = results;
        this.endReached = true;
        this.trigger('noResultsLeft');
      }

      if (response.data && response.data.meta) {
        this.count = response.data.meta.count;
        this.totalCount = response.data.meta.total_count;
      }
      return finalResults;
    },

    calculateOffset: function(page) {
      if (page <= this.currentPage) {
        return 0;
      } else {
        return this.currentPage * this.itemsPerPage;
      }
    },

    calculateLimit: function(page) {
      if (page <= this.currentPage) {
        return page * this.itemsPerPage + 1;
      } else {
        return (page - this.currentPage) * this.itemsPerPage + 1;
      }
    }

  });

});

